import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import MLayout from "./views/mobile/Layout.vue";
import PCLayout from "./views/computer/Layout.vue";
import { checkIsMobile } from "./utils/checkDevice";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import Toast from "@/components/common/Toast.vue";
import Store from "@/store/index";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_config_provider, { locale: _unref(zhCn) }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(checkIsMobile)() ? MLayout : PCLayout), null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["locale"]),
    _createVNode(Toast, {
      visible: _unref(Store).state.showToast,
      text: "查询中..."
    }, null, 8, ["visible"])
  ], 64))
}
}

})